export type Role = 'ojp_admin' | 'ojp_agent' | 'owner' | 'desk' | 'teacher' | 'bursar' | 'parent' | 'student' | 'applicant';

export function homeForRole(role: Role): string {
  if (role === 'ojp_admin' || role === 'ojp_agent') return '/login?error=use_admin_console';
  return `/${role}`;
}
